export enum SvcModalActionPlanTab {
    Feed = 0,
    Checklist = 1,
    Approval = 2,
    History = 3,
}
